module.exports = __webpack_public_path__ + "72f871e17ff65eb68ae75d713c41fdac.jpg";